export const CHART_KEY_HEADER_CHECKBOX = 'chartKeyHeaderCheckbox';
export const CHART_KEY_HEADER_FEATURE_DROPDOWN = 'chartKeyHeaderFeatureDropdown';
export const CHART_KEY_HEADER_PROPERTY_DROPDOWN = 'chartKeyHeaderPropertyDropdown';
export const CHART_KEY_HEADER_FEATURE_WINDOW_DROPDOWN = 'chartKeyHeaderFeatureWindowDropdown';
export const CHART_KEY_HEADER_FEATURES_TOGGLE = 'chartKeyHeaderFeaturesToggle';